import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CheckCircle2Icon } from 'lucide-react';
const bonuses = [{
  id: 1,
  title: 'Guía Pro SOS',
  subtitle: 'BONUS #1',
  desc: 'Cómo recuperar la calma discretamente en reuniones o llamadas de alto estrés.',
  value: '$47',
  image: 'https://cdn.magicpatterns.com/uploads/rtqbSsrMTJYV1qRY5DCXyM/bn-001.png'
}, {
  id: 2,
  title: 'Biohacking de Escritorio',
  subtitle: 'BONUS #2',
  desc: 'Transforma tu espacio de trabajo en una zona de enfoque absoluto.',
  value: '$47',
  image: 'https://cdn.magicpatterns.com/uploads/6SHPvx3KbTMC9xSApZdhN9/bn-002.png'
}, {
  id: 3,
  title: 'Higiene Mental 2026',
  subtitle: 'BONUS #3',
  desc: 'El manual para silenciar tu teléfono y recuperar tu dopamina.',
  value: '$37',
  image: 'https://cdn.magicpatterns.com/uploads/mMjcsHqaoHceKFoVbaVns4/bn-003.png'
}, {
  id: 4,
  title: 'El Tracker de Calma Neural',
  subtitle: 'BONUS #4',
  desc: 'Tu bitácora de 7 días para medir cómo baja tu ansiedad.',
  value: '$27',
  image: 'https://cdn.magicpatterns.com/uploads/v21NuDzDtC1eCj1ETseM9N/bn-004.png'
}, {
  id: 5,
  title: 'El Diccionario del Enfoque',
  subtitle: 'BONUS #5',
  desc: 'Suplementos y alimentos que bloquean el cortisol de forma natural.',
  value: '$27',
  image: 'https://cdn.magicpatterns.com/uploads/9vNqJFUBzeoUnAyU5ymQmQ/bn-005.png'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function ValueStack() {
  return <section className="pt-16 pb-10 md:py-24 px-4 bg-[#0d0d12] relative border-t border-white/5" data-id="element-124">
      <div className="max-w-6xl mx-auto" data-id="element-125">
        <div className="text-center mb-16" data-id="element-126">
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-127">
            Presentamos el Bundle Definitivo
          </h2>
          <p className="text-xl text-[#00d4ff] font-medium tracking-wide" data-id="element-128">
            EL PROTOCOLO DE PAUSA
          </p>
          <p className="text-gray-400 mt-4" data-id="element-129">
            Todo lo que necesitas para dominar tu estrés en un formato de
            lectura rápida.
          </p>
        </div>

        {/* Main Ebook */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="mb-12 p-1 rounded-3xl bg-gradient-to-b from-[#0ea5e9]/40 to-white/5 box-glow" data-id="element-130">
          <div className="bg-[#050507] rounded-[23px] p-8 md:p-12 flex flex-col md:flex-row items-center gap-10" data-id="element-131">
            <div className="w-full md:w-1/3 aspect-[3/4] rounded-xl overflow-hidden shadow-2xl shadow-black/50 relative" data-id="element-132">
              <img src="https://cdn.magicpatterns.com/uploads/6ythujXyKDnT8igMadZgrR/mk-001.png" alt="El Código del Cortisol" className="w-full h-full object-cover" data-id="element-133" />
            </div>

            <div className="w-full md:w-2/3 space-y-6" data-id="element-134">
              <div className="inline-block px-3 py-1 rounded-full bg-white/10 text-sm font-medium text-gray-300" data-id="element-135">
                EBOOK PRINCIPAL
              </div>
              <h3 className="text-3xl md:text-4xl font-bold" data-id="element-136">
                El Código del Cortisol
              </h3>
              <p className="text-xl text-gray-400 leading-relaxed" data-id="element-137">
                El mapa neurocientífico para resetear tu cerebro en 10 minutos.
                Aprende la mecánica exacta para desactivar la respuesta de
                estrés de tu cuerpo a voluntad.
              </p>
              <div className="flex items-center gap-3 text-2xl font-bold" data-id="element-138">
                <span className="text-gray-500 line-through decoration-red-500/50" data-id="element-139">
                  Valor: $97
                </span>
                <span className="text-[#00d4ff]" data-id="element-140">INCLUIDO</span>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Bonuses Grid */}
        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-141">
          {bonuses.map(bonus => <motion.div key={bonus.id} variants={itemVariants} className="bg-[#050507] rounded-2xl border border-white/5 overflow-hidden group hover:border-white/15 transition-colors" data-id="element-142">
              <div className="aspect-video w-full overflow-hidden relative bg-[#111]" data-id="element-143">
                <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500" data-id="element-144" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#050507] via-transparent to-transparent" data-id="element-145" />
              </div>
              <div className="p-6" data-id="element-146">
                <div className="text-[#0ea5e9] text-xs font-bold tracking-wider mb-2" data-id="element-147">
                  {bonus.subtitle}
                </div>
                <h4 className="text-xl font-bold mb-3" data-id="element-148">{bonus.title}</h4>
                <p className="text-sm text-gray-400 mb-6 h-10" data-id="element-149">{bonus.desc}</p>
                <div className="flex items-center justify-between pt-4 border-t border-white/5" data-id="element-150">
                  <span className="text-gray-500 line-through text-sm" data-id="element-151">
                    Valor: {bonus.value}
                  </span>
                  <span className="text-white font-medium text-sm flex items-center gap-1" data-id="element-152">
                    <CheckCircle2Icon className="w-4 h-4 text-[#00d4ff]" data-id="element-153" />{' '}
                    Incluido
                  </span>
                </div>
              </div>
            </motion.div>)}
        </motion.div>

        {/* Total Value */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center p-8 rounded-2xl bg-white/5 border border-white/10" data-id="element-154">
          <p className="text-gray-400 uppercase tracking-widest text-sm font-bold mb-2" data-id="element-155">
            Valor Total Acumulado
          </p>
          <p className="text-5xl font-bold text-white" data-id="element-156">$282.00 USD</p>
        </motion.div>
      </div>
    </section>;
}